const isDebugEnabled = process.env.NODE_ENV !== 'production';

export const debugInfo = (...args: any[]) => {
  if (isDebugEnabled) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (isDebugEnabled) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const debugError = (...args: any[]) => {
  if (isDebugEnabled) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
